'use strict';
import React, { Component } from 'react'
var FormatMessage = require('react-globalize').FormatMessage;

export default class News extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedImage: "",
    }
    this.carouselClick = this.carouselClick.bind(this);
  }

  carouselClick(image) {
    this.setState({
      selectedImage: image,
    }, () => {
      $('#promModal').modal('show');
    })
  }

  render () {
    return (
      <div className="container">
        <div className="row text-justify">
          {
            this.props.locale == "es" ?
            <div className="col-md-12" style={{padding:25}}>
              <div className="row">
                <div className="col-md-12">
                  <p>
                    <b>FedEx</b> no llama por telefono, no solicita por correo, no envia mensajes de texto 
                    o correo electrónico, pagos o información personal a cambio de mercancías en 
                    tránsito o bajo la custodia de FedEx. Si recibe alguna de estas comunicaciones 
                    u otras similares, no responda ni coopere. <b>ES UN ESTAFADOR</b>.
                  </p>
                  <p>Señales de advertencia comunes de esta estafa:</p>
                </div>
              </div>
              <div className="row" style={{marginTop:25}}> 
                <div className="col-md-6" style={{textAlign:"right"}}>
                  <div style={{height:"150px", width:"50%", margin:"auto"}}>
                    <img className="img-responsive" style={{height:150}} src="img/fraudFedex.png" alt="alert" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{height:"150px", width:"75%", padding:10, margin:"auto"}}>
                    <ol>
                      <li>Solicitudes inesperadas de dinero a cambio de la entrega de un 
                        paquete, a menudo con un sentido de urgencia.
                      </li>
                      <li>Solicitudes de dinero para cubrir un cheque devuelto. </li>
                      <li>Solicitudes de información personal y / o financiera. </li>
                      <li>Enlaces a direcciones de sitios web mal escritas o 
                        ligeramente modificadas (fedx.com, fed-ex.com, etc.)</li>
                    </ol>
                  </div>
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-12">
                  <p>
                    No contestar o si contesta haga caso omiso a las instrucciones. Consulte 
                    con su supervisor de manera inmediata.
                  </p>
                  <p style={{color:"red", fontWeight:"bold", textAlign: "center"}}>
                    Por favor, estemos alertas… NO CAIGAMOS EN LA TRAMPA….
                  </p>
                </div>
              </div>
              {/**LINKS */}
              <div className="row" style={{padding:25, textAlign:""}}>
                <div className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>Información de ayuda:</p>
                  <p><a href="" onClick={(e) => { e.preventDefault(); this.carouselClick('covidFraud.png') }}>Alertas de estafa Covid 19</a></p>
                  <p>
                    <a href="" onClick={(e) => { e.preventDefault(); this.carouselClick('fraudcall.png') }}>
                      Si intentan extorsionarte por teléfono, contéstales así a los delincuentes.
                    </a>
                  </p>
                  <p>
                    <a href="" onClick={(e) => { e.preventDefault(); this.carouselClick('EvitarEstafaVacunaCovid-es.jpg') }}>
                      Tres formas de evitar las estafas de la vacuna COVID-19.
                    </a>                   
                  </p>
                </div>
              </div>
            </div>

            :

            <div className="col-md-12" style={{padding:25}}>
              <div className="row">
                <div className="col-md-12">
                  <p>
                    <b>FedEx</b> does not call by phone, does not request by mail, does not send 
                    text messages or email, payments or personal information in exchange for 
                    goods in transit or in the custody of FedEx. If you receive any of these 
                    or similar communications, do not respond or cooperate. <b>IS A FRAUDSTER</b>.
                  </p>
                  <p>Common warning signs of this scam:</p>
                </div>
              </div>
              <div className="row" style={{marginTop:25}}> 
                <div className="col-md-6" style={{textAlign:"right"}}>
                  <div style={{height:"150px", width:"50%", margin:"auto"}}>
                    <img className="img-responsive" style={{height:150}} src="img/fraudFedex.png" alt="alert" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{height:"150px", width:"75%", padding:10, margin:"auto"}}>
                    <ol>
                      <li>Unexpected requests for money in exchange for delivery of 
                        a package, often with a sense of urgency.
                      </li>
                      <li>Requests for money to cover a returned check.</li>
                      <li>Requests for personal and/or financial information.</li>
                      <li>Links to misspelled or slightly modified website 
                        addresses (fedx.com, fed-ex.com,etc.)</li>
                    </ol>
                  </div>
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-12">
                  <p>
                    Do not answer or if you answer, ignore the instructions. Check with 
                    your supervisor immediately.
                  </p>
                  <p style={{color:"red", fontWeight:"bold", textAlign: "center"}}>
                    Please, let's be alert... LET'S NOT FALL INTO THE TRAP....
                  </p>
                </div>
              </div>

              {/** LINKS */}
              <div className="row" style={{padding:25, textAlign:""}}>
                <div className="col-md-6">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>Help Information:</p>
                  <p><a href="" onClick={(e) => { e.preventDefault(); this.carouselClick('covidFraud.png') }}>
                    Scam Alerts Covid 19</a></p>
                  <p>
                    <a href="" onClick={(e) => { e.preventDefault(); this.carouselClick('fraudcall.png') }}>
                      Hang Up Your Phone to Impostor Scams.
                    </a>
                  </p>
                  <p>
                    <a href="" onClick={(e) => { e.preventDefault(); this.carouselClick('EvitarEstafaVacunaCovid-en.jpg') }}>
                    Three Ways to Avoid COVID-19 Vaccine Scams.
                    </a>                   
                  </p>
                </div>
              </div>
            </div>
          }
        </div>

        <div className="modal fade " id="promModal" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>

              </div>
              <div className="modal-body">
                <img src={"img/" + this.state.selectedImage} alt="" className="img-responsive" id="detailImage" />
              </div>

            </div>
          </div>
        </div>

      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./js/fraudAwareContent/news.js